module.exports = __webpack_public_path__ + "img/tree-03-b-trunk.923c2e95.png";